import React, { useState, useEffect } from 'react';

interface ServiceSlideProps {
  images: string[];
  alt: string;
  className?: string;
}

const ServiceSlide: React.FC<ServiceSlideProps> = ({ images, alt, className = "" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
      {images.map((image, index) => (
        <img
          key={image}
          src={image}
          alt={alt}
          className={className}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: index === currentIndex ? 1 : 0,
            transition: 'opacity 1.5s ease-in-out'
          }}
        />
      ))}
    </div>
  );
};

export default ServiceSlide; 